import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabaseClient'

interface UserRow { id: string; email: string | null; full_name: string | null; role: 'ADMIN'|'ADVISOR'|'CLIENT'|'PROSPECT' | null }

export function UsersAdmin() {
  const [users, setUsers] = useState<UserRow[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    const load = async () => {
      setLoading(true)
      const { data } = await supabase.from('profiles').select('id, email, full_name, role').order('role')
      if (!mounted) return
      setUsers((data as any[]) ?? [])
      setLoading(false)
    }
    load()
    return () => { mounted = false }
  }, [])

  const changeRole = async (id: string, role: UserRow['role']) => {
    if (!role) return
    setUsers((prev) => prev.map((u) => (u.id === id ? { ...u, role } : u)))
    await supabase.from('profiles').update({ role }).eq('id', id)
  }

  return (
    <div className="card">
      <h2 className="text-xl font-semibold mb-4">Users & Roles</h2>
      {loading ? (
        <div className="text-gray-600">Loading...</div>
      ) : (
        <div className="space-y-3">
          {users.map((u) => (
            <div key={u.id} className="flex items-center justify-between">
              <div>
                <div className="font-medium">{u.full_name || u.email || u.id.slice(0, 8)}</div>
                <div className="text-xs text-gray-500">{u.email}</div>
              </div>
              <select className="input-field" value={u.role ?? 'PROSPECT'} onChange={(e) => changeRole(u.id, e.target.value as any)}>
                <option value="ADMIN">ADMIN</option>
                <option value="ADVISOR">ADVISOR</option>
                <option value="CLIENT">CLIENT</option>
                <option value="PROSPECT">PROSPECT</option>
              </select>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}


